import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { WaitlistStatus } from '@/types/serviceArea'

import { findMockWaitlistStatus } from './waitlistMocks'

export interface GetOpenWaitlistParams {
  /** 조회할 주소 (예: "청주시 상당구 하하동 33-2") */
  address: string
}

/**
 * 오픈 알림 신청 현황 조회.
 *
 * 결과 화면(수거 불가능) 진입 시 호출 — 사용자가 이미 신청했는지(isCompleted),
 * 현재 대기 인원수(waitingCount)를 받아 UI 분기.
 *
 * 인증: Bearer (회원만 호출 가능)
 */
export const apiGetOpenWaitlist = async ({ address }: GetOpenWaitlistParams): Promise<WaitlistStatus> => {
  if (IS_MOCK) {
    await mockDelay()
    return findMockWaitlistStatus(address)
  }
  return await api.get<WaitlistStatus>('/service-area/waitlist', {
    params: { address },
  })
}
